// extracted by mini-css-extract-plugin
export default {"heading":"Landing_heading__qaZcS","icon":"Landing_icon__tjsPW"};